import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/img_search_disable_provision.svg'
import _imports_1 from '@/assets/img/img_entry_complete.svg'


const _withScopeId = n => (_pushScopeId("data-v-d1ca92aa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "entry_base_regist_complete_contents_wrapper" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<img class=\"entry_complete_img\" src=\"" + _imports_0 + "\" alt=\"\" data-v-d1ca92aa><h1 class=\"entry_complete_title\" data-v-d1ca92aa>キャリアシートの入力</h1><div class=\"entry_complete_description\" data-v-d1ca92aa><p class=\"entry_complete_description_text\" data-v-d1ca92aa>アカウントが作成されました。続けて、キャリアシートをご入力ください。</p><p class=\"entry_complete_description_text\" data-v-d1ca92aa>キャリアシートは、あなたのこれまでのご経験や、ご希望条件をまとめたものです。</p><p class=\"entry_complete_description_text\" data-v-d1ca92aa>キャリアコンサルタントがこちらの情報をもとに面談し、転職相談を承ります。</p><p class=\"entry_complete_description_text\" data-v-d1ca92aa>また、応募企業へ提出する情報も含まれます。</p></div><div class=\"entry_complete_flow\" data-v-d1ca92aa><p class=\"entry_complete_flow_title\" data-v-d1ca92aa>応募までの流れ</p><img class=\"entry_complete_flow_img\" src=\"" + _imports_1 + "\" alt=\"\" data-v-d1ca92aa></div><p class=\"entry_complete_note\" data-v-d1ca92aa>途中まで入力した情報は保持されます</p>", 5)
const _hoisted_7 = { class: "entry_base_button" }

import { useRouter } from 'vue-router';
import BaseButton from '@/components/BaseButton.vue';
import { ref, onMounted } from 'vue';
import store from '@/store';
import cookies from 'vue-cookies';

export default /*#__PURE__*/_defineComponent({
  __name: 'RegistComplete',
  setup(__props) {

const isLoading = ref(false);
const router = useRouter();
const transitionNextPage = () => {
  router.push({ name: 'c00' });
};
//gtmタグ
onMounted(async () => {
  isLoading.value = true;
  try {
    await store.dispatch('careerId/receive');
    window.parent.dataLayer.push({'userId01': store.getters['careerId/careerId']});

  // cookieに格納
  if (cookies.isKey('userId01_c') === false) {
    cookies.set('userId01_c', store.getters['careerId/careerId']);
  }

  } catch (e) {
    store.dispatch('toasts/appendTimeToast', { label: '求職者情報の取得に失敗しました', duration: null });
  } finally {
    isLoading.value = false;
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_7, [
        _createVNode(BaseButton, {
          onClick: transitionNextPage,
          theme: "primary",
          type: "button"
        }, {
          default: _withCtx(() => [
            _createTextVNode("キャリアシートを入力（約10分）")
          ]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})